import { render, staticRenderFns } from "./ClientInsights.vue?vue&type=template&id=eb6ff870&scoped=true&"
import script from "./ClientInsights.vue?vue&type=script&lang=js&"
export * from "./ClientInsights.vue?vue&type=script&lang=js&"
import style0 from "./ClientInsights.vue?vue&type=style&index=0&id=eb6ff870&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6ff870",
  null
  
)

export default component.exports